import React from 'react';
import classes from './inStream.css';
import compareImg from '../../assets/compare.png';
import {getIndexProtectorLabel} from "../../shared/common";

const disclaimer = () => {
    return (
        <div className={classes.instreamPage}>
            <h3>Exclusive for MassMutual Ascend</h3>
            <p>
                Time is Money. We won’t waste either.
            </p>
            <p>
                inStream is designed for scalable financial planning that saves you time and earns you more. Start with
                this simple calculator and evolve into better financial plans designed to illustrate the value that you
                bring to every prospect and client relationship.
            </p>
            <p>
                Through our work with Dr. Wade Pfau, Professor of Retirement Income at The American College, we build
                innovative and powerful financial planning software. And through our partnership with MassMutual Ascend, we are
                pleased to make an exclusive offer to you that combines our academically rigorous <b>Financial Planning</b>&nbsp;
                 platform with innovative tools like our <b>Fixed Index Annuity Module</b>, customizable <b>CAPM assumptions</b>,
                proactive <b>Tracking Plans</b>, automated <b>Quick Plans</b>, and so much more.
            </p>
            <p>
                To learn more about inStream today and start planning for better futures tomorrow, <a href="mailto:sales@instreamwealth.com">click here</a>.
            </p>
            <div className={classes.imageContainer}>
                <img className={classes.compareImg} alt="inStream Solutions" src={compareImg} />
            </div>

        </div>
    );
};

export default disclaimer;


// WEBPACK FOOTER //
// ./src/components/inStream/inStream.js